import { useEffect, useRef, useState } from "react";

interface Props {
  className?: string;
  countdown: number;
}

export const CountingIndicator: React.FC<Props> = ({ className, countdown }) => {
  const [progress, setProgress] = useState(0);
  const [displayCount, setDisplayCount] = useState(countdown);
  const [initialCountdown] = useState(countdown);
  const startTimestamp = useRef<number | null>(null);

  useEffect(() => {
    let animationFrameId: number;
    const duration = initialCountdown * 1000;

    const animate = (timestamp: number) => {
      startTimestamp.current ||= timestamp;

      const elapsed = timestamp - startTimestamp.current;
      const fraction = Math.min(elapsed / (duration - 150), 1); // 150ms for the animation to finish

      setProgress(fraction * 100);

      const remainingSeconds = Math.ceil((duration - elapsed) / 1000);
      setDisplayCount(remainingSeconds > 0 ? remainingSeconds : 1);

      if (fraction < 1) {
        animationFrameId = requestAnimationFrame(animate);
      }
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationFrameId);
      startTimestamp.current = null;
    };
  }, [initialCountdown]);

  return (
    <div className={`assignment-audio__countdown-indicator ${className ?? ""}`}>
      <svg viewBox="0 0 36 36" className="assignment-audio__countdown-indicator-svg">
        <path
          className="assignment-audio__countdown-indicator-progress"
          strokeDasharray={`${progress}, 100`}
          d="M18 2.0845
             a 15.9155 15.9155 0 0 1 0 31.831
             a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <text className="assignment-audio__countdown-indicator-number" x="18" y="23" textAnchor="middle">
          {displayCount}
        </text>
      </svg>
    </div>
  );
};
